export enum INSPECTION_TYPES {
  PRELIMINARY = 'preliminary',
  EFFECTIVE = 'effective',
}

export default INSPECTION_TYPES;

